module.exports = __webpack_public_path__ + "resources/img/bg_banner_inquiry.a458da219250f44485fbe9bea23839bb.png";